import { apiFetch } from "../client"

export function listReportTemplates() {
  return apiFetch<any>("/reports/templates")
}

export function generateReport(payload: object) {
  return apiFetch<any>("/reports/generate", {
    method: "POST",
    rawBody: payload,
  })
}

export function listReportHistory(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/reports/history${query}`)
}

export function listReportSchedules(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/reports/schedules${query}`)
}

export function createReportSchedule(payload: object) {
  return apiFetch<any>("/reports/schedules", {
    method: "POST",
    rawBody: payload,
  })
}

export function updateReportSchedule(scheduleId: string, payload: object) {
  return apiFetch<any>(`/reports/schedules/${scheduleId}`, {
    method: "PATCH",
    rawBody: payload,
  })
}

export function runReportSchedule(scheduleId: string) {
  return apiFetch<any>(`/reports/schedules/${scheduleId}/run`, {
    method: "POST",
  })
}

export async function downloadReportRun(runId: string) {
  const token = localStorage.getItem("session_token")
  const response = await fetch(`/api/v1/reports/runs/${runId}/download`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  })

  if (!response.ok) {
    throw new Error("Unable to download report")
  }

  const blob = await response.blob()
  const objectUrl = URL.createObjectURL(blob)
  const link = document.createElement("a")
  const disposition = response.headers.get("Content-Disposition")
  const match = disposition?.match(/filename="(.+)"/)
  link.href = objectUrl
  link.download = match?.[1] ?? `${runId}.dat`
  link.click()
  URL.revokeObjectURL(objectUrl)
}
